// create a reducer for the filters context usign createSlice from redux-toolkit
import { createSlice } from '@reduxjs/toolkit';
import { StudentFiltersEnum, TeacherFiltersEnum } from 'src/modules/shared/constants';

export type FilterMode = 'bookOverview' | 'trajectory' | 'scoring';

export interface IFiltersState {
  showFilters: boolean;
  enabledFilters: (TeacherFiltersEnum | StudentFiltersEnum)[];
  activeFilter?: TeacherFiltersEnum | StudentFiltersEnum;
  filterMode?: FilterMode;
  refresh: boolean;
  isOutdated: boolean;
  noResultsFound: boolean;
  hideFilterButtons: boolean;
  newResults: boolean;
  selectedGroup?: string;
  selectedStudent?: string;
  selectedGrade?: string;
  defaultGroupInSelectedGrade?: string;
  hasSubHeader: boolean;
  isFetching?: boolean
}

const initialState: IFiltersState = {
  showFilters: false,
  enabledFilters: [],
  activeFilter: undefined,
  filterMode: undefined,
  refresh: false,
  isOutdated: false,
  noResultsFound: false,
  hideFilterButtons: false,
  newResults: false,
  selectedGroup: '',
  selectedStudent: '',
  selectedGrade: '',
  defaultGroupInSelectedGrade: '',
  hasSubHeader: false,
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setShowFilters: (state, action) => {
      state.showFilters = action.payload;
    },
    setEnabledFilters: (state, action) => {
      state.enabledFilters = action.payload;
    },
    setActiveFilter: (state, action) => {
      state.activeFilter = action.payload;
    },
    setFilterMode: (state, action) => {
      state.filterMode = action.payload;
    },
    setRefresh: (state, action) => {
      state.refresh = action.payload;
    },
    setIsOutdated: (state, action) => {
      state.isOutdated = action.payload;
    },
    setNoResultsFound: (state, action) => {
      state.noResultsFound = action.payload;
    },
    setHideFilterButtons: (state, action) => {
      state.hideFilterButtons = action.payload;
    },
    setNewResults: (state, action) => {
      state.newResults = action.payload;
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroup = action.payload;
    },
    setSelectedStudent: (state, action) => {
      state.selectedStudent = action.payload;
    },
    setSelectedGrade: (state, action) => {
      state.selectedGrade = action.payload;
    },
    setDefaultGroupInSelectedGrade: (state, action) => {
      state.defaultGroupInSelectedGrade = action.payload;
    },
    setHasSubheader: (state, action) => {
      state.hasSubHeader = action.payload;
    },
    setIsFetching: (state, action: {payload: boolean}) => {
      state.isFetching = action.payload
    }
  },
});

export const {
  setShowFilters,
  setEnabledFilters,
  setActiveFilter,
  setFilterMode,
  setRefresh,
  setIsOutdated,
  setNoResultsFound,
  setHideFilterButtons,
  setNewResults,
  setSelectedGrade,
  setSelectedGroup,
  setSelectedStudent,
  setDefaultGroupInSelectedGrade,
  setHasSubheader,
  setIsFetching,
} = filtersSlice.actions;

export const { reducer: filtersReducer } = filtersSlice;
